<tour-step-template>
  <ng-template let-step="step">
    <mat-card class="tour-step">
      <button
        mat-icon-button
        type="button"
        class="tour-step__close"
        (click)="tourService.end()"
        aria-label="End tour"
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
      <mat-card-header>
        <div class="tour-step__header">
          <span class="tour-step__step-mark" *ngIf="tourService.steps?.length" aria-hidden="true">
            {{ tourService.steps.indexOf(step) + 1 }}
          </span>
          <mat-card-title class="tour-step__title">
            <span class="tour-step__title-main">{{ step.title }}</span>
            <span class="tour-step__title-context" *ngIf="step.tourLabel">{{ step.tourLabel }}</span>
<!--          <p style="font-size: 14px; margin-top: -10px; color: gray;">{{ step.route }}</p>-->
          </mat-card-title>
        </div>
      </mat-card-header>
      <div class="tour-step__scroll-area" [class.tour-step__scroll-area--compressed]="isTocOpen">
        <div class="tour-step__body" [class.tour-step__body--with-media]="step.media?.type">
          <mat-card-content class="tour-step__content">
            <ng-container *ngIf="asRichContent(step) as content; else legacyContent">
              <div class="tour-step__content-section-first" *ngIf="content.shortDescription" [innerHTML]="content.shortDescription"></div>
              <div class="tour-step__content-section" *ngIf="content.longDescription" [innerHTML]="content.longDescription"></div>
              <div class="tour-step__content-section" *ngIf="content.impactOnSystem" [innerHTML]="content.impactOnSystem"></div>
              <div class="tour-step__content-section" *ngIf="content.risks" [innerHTML]="content.risks"></div>
            </ng-container>
            <ng-template #legacyContent>
              <div [innerHTML]="step.content"></div>
            </ng-template>
          </mat-card-content>
          <ng-container *ngIf="step.media?.type">
            <div
              class="tour-step__media"
              [style.flexBasis.px]="step.media.maxWidth ?? 320"
              [style.maxWidth.px]="step.media.maxWidth ?? 320"
            >
              <video
                *ngIf="step.media.type === 'video'"
                class="tour-step__media-video"
                [attr.src]="step.media.src"
                autoplay
                loop
                muted
                playsinline
                [attr.width]="step.media.maxWidth ?? 320"
                [attr.height]="step.media.height ?? 180"
              ></video>
              <img
                *ngIf="step.media.type === 'image'"
                class="tour-step__media-image"
                [attr.src]="step.media.src"
                [attr.alt]="step.media.alt ?? step.title"
                [attr.width]="step.media.maxWidth ?? 320"
                [attr.height]="step.media.height ?? null"
              />
            </div>
          </ng-container>
        </div>
      </div>

      <button
        type="button"
        mat-stroked-button
        class="tour-step__toc-toggle"
        *ngIf="tourService.steps?.length"
        (click)="onToggleToc($event)"
      >
        <mat-icon inline [svgIcon]="isTocOpen ? 'arrow-up' : 'arrow-down'"></mat-icon>
        <span>{{ isTocOpen ? 'Hide steps' : 'Show steps' }}</span>
      </button>

      <nav class="tour-step__toc" *ngIf="isTocOpen && tourService.steps?.length">
        <button
          type="button"
          mat-button
          class="tour-step__toc-item"
          *ngFor="let tocStep of tourService.steps; let index = index; trackBy: trackStep"
          [class.tour-step__toc-item--active]="tocStep === tourService.currentStep"
          (click)="onSelectStep($event, index)"
        >
          <span class="tour-step__toc-index">{{ index + 1 }}.</span>
          <span class="tour-step__toc-title">{{ tocStep.title }}</span>
        </button>
      </nav>

      <mat-card-actions [class.tour-step__actions-no-progress]="!step.showProgress">
        <button
          mat-stroked-button
          type="button"
          class="tour-step__action-button tour-step__action-button--secondary"
          [disabled]="!tourService.hasPrev(step)"
          (click)="tourService.prev()"
        >
          <mat-icon svgIcon="arrow-left"></mat-icon>
          {{ step.prevBtnTitle }}
        </button>

        <div class="tour-step__progress" *ngIf="step.showProgress && tourService.steps">
          {{ tourService.steps.indexOf(step) + 1 }} / {{ tourService.steps.length }}
        </div>

        <button
          mat-flat-button
          color="primary"
          type="button"
          class="tour-step__action-button tour-step__action-button--primary"
          *ngIf="tourService.hasNext(step) && !step.nextOnAnchorClick"
          (click)="tourService.next()"
        >
          {{ step.nextBtnTitle }}
          <mat-icon svgIcon="arrow-right"></mat-icon>
        </button>

        <button
          mat-flat-button
          color="primary"
          type="button"
          class="tour-step__action-button tour-step__action-button--primary"
          *ngIf="!tourService.hasNext(step)"
          (click)="tourService.end()"
        >
          {{ step.endBtnTitle }}
        </button>
      </mat-card-actions>
    </mat-card>
  </ng-template>
</tour-step-template>
